import { useLanguage } from "@/contexts/LanguageContext";
import { SERVICES } from "@shared/services";
import { ServiceDetails } from "@/components/ServiceOverview";
import { HowWeWork } from "@/components/HowWeWork";
import { ServiceOffers, InvestmentInquiryBanner } from "@/components/ServiceOffers";
import { Button } from "@/components/ui/button";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";
import { ArrowRight } from "lucide-react";
import { Link } from "wouter";
export default function Services() {
  const {
    tx,
    tf,
    href: localeHref,
    dateLocale
  } = useLanguage();
  useDocumentMeta("Services rund um Nordzypern | CYPRUS PRIVÉ", "Immobilien, Nordzypern kennenlernen, Firmengründung, Bankkontoeröffnung und internationaler Umzugsservice. Ein Ansprechpartner und spezialisierte Partner. Investments auf Anfrage.");
  const schema = {
    "@context": "https://schema.org",
    "@type": "OfferCatalog",
    name: "Services rund um Nordzypern",
    itemListElement: SERVICES.map(item => ({
      "@type": "Offer",
      itemOffered: {
        "@type": "Service",
        name: item.name,
        description: item.description,
        provider: {
          "@type": "Organization",
          name: "CYPRUS PRIVÉ"
        }
      }
    }))
  };
  return <main>
    <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify(schema)
    }} />
    <section className="bg-[#101010] py-20 text-white lg:py-28"><div className="container"><p className="text-[10px] font-bold tracking-[.2em] text-[#D8BC88]">{tx("CYPRUS PRIVÉ / SERVICES")}</p><div className="mt-6 grid gap-9 lg:grid-cols-[1.2fr_.8fr] lg:items-end"><h1 className="display-lg font-semibold">{tx("Ihr Service rund um Nordzypern.")}</h1><div><p className="text-xl leading-8">{tx("Ein Ansprechpartner.")}<br />{tx("Ein Netzwerk aus Spezialisten.")}</p><p className="mt-5 text-sm leading-8 text-white/75">{tx("Von der ersten Orientierung bis zur Umsetzung begleiten wir Ihre Immobilien-, Business-, Banking- und Relocation-Vorhaben. Persönlich, abgestimmt und ohne Kaufdruck.")}</p><Button asChild variant="outline" className="mt-7 rounded-none border-white/40 bg-transparent text-xs text-white hover:bg-white hover:text-black"><Link href="/kontakt">{tx("PERSÖNLICHES GESPRÄCH ")}<ArrowRight /></Link></Button></div></div><nav aria-label={tx("Leistungsbereiche")} className="mt-12 flex flex-wrap gap-3 border-t border-white/20 pt-8">{tx(SERVICES.map(service => <a key={service.id} href={`#${service.id}`} className="flex items-center gap-3 border border-white/25 px-4 py-3 text-xs transition-colors hover:bg-white hover:text-black"><span className="opacity-60">{tx(service.number)}</span>{tx(service.shortName)}</a>))}</nav><Link href="/private-investments" className="mt-7 inline-flex items-center gap-3 text-sm text-[#E1C998]">{tx("Investments ausschließlich auf Anfrage · individuelle Konditionen ")}<ArrowRight className="h-4 w-4 shrink-0" /></Link></div></section>
    <div className="bg-[#FFFDF9]"><div className="container">{tx(SERVICES.map(service => <ServiceDetails key={service.id} serviceId={service.id} />))}</div></div>
    <HowWeWork />
    <InvestmentInquiryBanner />
    <ServiceOffers />
  </main>;
}
